
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <M mdxType="M">Die Schweiz geht im Durchschnitt um ca. 23.10 Uhr zu Bett, wacht knapp vor 7 Uhr auf und schläft ziemlich genau 7,9 Stunden</M> – die Frauen etwa eine halbe Stunde länger als die Männer. <Link href='https://advances.sciencemag.org/content/2/5/e1501705' mdxType="Link">Diese Daten haben amerikanische Forscher</Link> in einem internationalen Schlafvergleich mittels Handydaten herausgefiltert. Gemäss einer Umfrage des Bundesamtes für Umwelt (Bafu) schlafen die Schweizer im Schnitt 7,5 Stunden an Werktagen, an freien Tagen 8,5. Was den Schlaf betrifft, verhalten wir Schweizer uns ziemlich genau wie die Dänen, schlafen aber rund 6 Minuten länger als die Deutschen und 12 Minuten weniger als die Holländer. Andererseits schlafen die Spanier etwa gleich lang, gehen jedoch im Durchschnitt erst knapp vor Mitternacht ins Bett, dafür schlafen sie bis 7.45 Uhr aus. <M mdxType="M">Am wenigsten schlafen Menschen in Japan und Singapur – gerade mal 7 Stunden und 24 Minuten.</M>
    <br /><br />
Laut den Forschern um Daniel B. Forger von der University of Michigan wird die Einschlafzeit von gesellschaftlichen und kulturellen Gegebenheiten beeinflusst, die Aufwachzeit hingegen von der inneren Uhr. Vor allem das längere Aufbleiben werde vom sozialen Umfeld dirigiert. 
    <br /><br />
Was weltweit aber gleich bleibt, ist das Problem von Schlafstörungen. Schlaflosigkeit zählt laut der WHO zu den grössten Gesundheitsgefahren des 21. Jahrhunderts. <M mdxType="M">Fast jeder dritte Schweizer leidet unter Schlafstörungen, bei 10 bis 20 Prozent ist es gar chronisch.</M> Wir schlafen in der Schweiz 38 Minuten weniger als noch vor gut 30 Jahren, weil wir später ins Bett gehen. Dies hat eine repräsentative Befragung von Forschern der Universitäten Basel und Zürich ergeben. Unser Lebensstil ist mediterraner geworden. Fussballmatches beginnen erst um 21 Uhr, die Jungen gehen immer später in den Ausgang.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;